import React from "react"
import Fade from "react-reveal/Fade"
import cx from 'clsx';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import BrandCardHeader from '@mui-treasury/components/cardHeader/brand';
import TextInfoContent from '@mui-treasury/components/content/textInfo';
import { useN03TextInfoContentStyles } from '@mui-treasury/styles/textInfoContent/n03';
import { useBlogTextInfoContentStyles } from '@mui-treasury/styles/textInfoContent/blog';
import { useLightTopShadowStyles } from '@mui-treasury/styles/shadow/lightTop';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles(() => ({
    root: {
        maxWidth: 334,
        borderRadius: 20,
    },
    content: {
        padding: 24,
    },
}))

const useGridStyles = makeStyles(({ breakpoints }) => ({
    root: {
        [breakpoints.up('sm')]: {
            justifyContent: 'center',
        },
    },
}));

const Courses = () => {

    const styles = useBlogTextInfoContentStyles();
    const shadowStyles = useLightTopShadowStyles();
    const cardStyles = useStyles()
    const gridStyles = useGridStyles();

    return (
        <div className="section" id="courses">
            <div className="container">
                <div className="research-container">
                    <Fade bottom cascade>
                        <h1>Courses</h1>
                    </Fade>

                    <Fade bottom cascade>
                        <Grid
                            style={{ padding: 16 }}
                            classes={gridStyles}
                            container
                            spacing={4}
                            justify="flex-start"
                        >
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                <Card className={cx(cardStyles.root, shadowStyles.root)}>
                                    <BrandCardHeader
                                        image={
                                            'https://firebasestorage.googleapis.com/v0/b/my-portfolio-a8cf3.appspot.com/o/logos%2FcourseraLogo.png?alt=media&token=a39a258d-f8f3-4587-9fe6-d3c8c2805b8a'
                                        }

                                    />
                                    <CardContent className={cardStyles.content}>
                                        <TextInfoContent
                                            classes={styles}
                                            overline={'University Of Michigan'}
                                            heading={'Building Database Applications in PHP'}
                                            body={
                                                ''
                                            }
                                        />
                                        <Button href="https://www.coursera.org/account/accomplishments/certificate/C99C3H6GMF9D" className={styles.button}>Certificate</Button>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4} lg={4} order={{ xs: 3, sm: 2 }}>
                                <Card className={cx(cardStyles.root, shadowStyles.root)}>
                                    <BrandCardHeader
                                        image={
                                            'https://firebasestorage.googleapis.com/v0/b/my-portfolio-a8cf3.appspot.com/o/logos%2FcourseraLogo.png?alt=media&token=a39a258d-f8f3-4587-9fe6-d3c8c2805b8a'
                                        }

                                    />
                                    <CardContent className={cardStyles.content}>
                                        <TextInfoContent
                                            classes={styles}
                                            overline={'The Hong Kong University'}
                                            heading={'Web Development with React Specialisation'}
                                            body={
                                                ''
                                            }
                                        />
                                        <Button href="https://www.coursera.org/account/accomplishments/specialization/certificate/ZDDBFPCCFJ94" className={styles.button}>Certificate</Button>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4} lg={4} order={{ xs: 2, sm: 3 }}>
                                <Card className={cx(cardStyles.root, shadowStyles.root)}>
                                    <BrandCardHeader
                                        image={
                                            'https://firebasestorage.googleapis.com/v0/b/my-portfolio-a8cf3.appspot.com/o/logos%2FcourseraLogo.png?alt=media&token=a39a258d-f8f3-4587-9fe6-d3c8c2805b8a'
                                        }

                                    />
                                    <CardContent className={cardStyles.content}>
                                        <TextInfoContent
                                            classes={styles}
                                            overline={'University Of Washington'}
                                            heading={'Machine Learning Foundations'}
                                            body={
                                                ''
                                            }
                                        />
                                        <Button href="https://www.coursera.org/account/accomplishments/certificate/K265HPQLL9DV" className={styles.button}>Certificate</Button>
                                    </CardContent>
                                </Card>
                            </Grid>

                        </Grid>

                        <Grid
                            style={{ padding: 16 }}
                            classes={gridStyles}
                            container
                            spacing={4}
                            justify="flex-start"
                        >
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                <Card className={cx(cardStyles.root, shadowStyles.root)}>
                                    <BrandCardHeader
                                        image={
                                            'https://firebasestorage.googleapis.com/v0/b/my-portfolio-a8cf3.appspot.com/o/logos%2FcourseraLogo.png?alt=media&token=a39a258d-f8f3-4587-9fe6-d3c8c2805b8a'
                                        }

                                    />
                                    <CardContent className={cardStyles.content}>
                                        <TextInfoContent
                                            classes={styles}
                                            overline={'Google'}
                                            heading={'How Google does Machine Learning'}
                                            body={
                                                ''
                                            }
                                        />
                                        <Button href="https://www.coursera.org/account/accomplishments/certificate/JTC6KPSP62CF" className={styles.button}>Certificate</Button>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4} lg={4} order={{ xs: 3, sm: 2 }}>
                                <Card className={cx(cardStyles.root, shadowStyles.root)}>
                                    <BrandCardHeader
                                        image={
                                            'https://firebasestorage.googleapis.com/v0/b/my-portfolio-a8cf3.appspot.com/o/logos%2FcourseraLogo.png?alt=media&token=a39a258d-f8f3-4587-9fe6-d3c8c2805b8a'
                                        }

                                    />
                                    <CardContent className={cardStyles.content}>
                                        <TextInfoContent
                                            classes={styles}
                                            overline={'deeplearning.ai'}
                                            heading={'Deep Learning Professional Specialization'}
                                            body={
                                                ''
                                            }
                                        />
                                        <Button href="https://www.coursera.org/account/accomplishments/specialization/certificate/FME7FCBH2T5T" className={styles.button}>Certificate</Button>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4} lg={4} order={{ xs: 2, sm: 3 }}>
                                <Card className={cx(cardStyles.root, shadowStyles.root)}>
                                    <BrandCardHeader
                                        image={
                                            'https://firebasestorage.googleapis.com/v0/b/my-portfolio-a8cf3.appspot.com/o/logos%2FcourseraLogo.png?alt=media&token=a39a258d-f8f3-4587-9fe6-d3c8c2805b8a'
                                        }

                                    />
                                    <CardContent className={cardStyles.content}>
                                        <TextInfoContent
                                            classes={styles}
                                            overline={'deeplearning.ai'}
                                            heading={'TensorFlow in Practice Specialization'}
                                            body={
                                                ''
                                            }
                                        />
                                        <Button href="https://www.coursera.org/account/accomplishments/specialization/certificate/HLXADFJXNW4N" className={styles.button}>Certificate</Button>
                                    </CardContent>
                                </Card>
                            </Grid>



                        </Grid>

                        <Grid
                            style={{ padding: 16 }}
                            classes={gridStyles}
                            container
                            spacing={4}
                            justify="flex-start"
                        >
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                <Card className={cx(cardStyles.root, shadowStyles.root)}>
                                    <BrandCardHeader
                                        image={
                                            'https://firebasestorage.googleapis.com/v0/b/my-portfolio-a8cf3.appspot.com/o/logos%2FudemyLogo.png?alt=media&token=4e02e529-8d2b-42bc-b4a3-83d21940bee0'
                                        }

                                    />
                                    <CardContent className={cardStyles.content}>
                                        <TextInfoContent
                                            classes={styles}
                                            overline={'Udemy'}
                                            heading={'Mastering Data Structures And Algorithms'}
                                            body={
                                                ''
                                            }
                                        />
                                        <Button href="http://ude.my/UC-4d526da6-88b2-45f3-ba2c-725a82c2647f" className={styles.button}>Certificate</Button>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4} lg={4} order={{ xs: 3, sm: 2 }}>
                                <Card className={cx(cardStyles.root, shadowStyles.root)}>
                                    <BrandCardHeader
                                        image={
                                            'https://firebasestorage.googleapis.com/v0/b/my-portfolio-a8cf3.appspot.com/o/logos%2FudemyLogo.png?alt=media&token=4e02e529-8d2b-42bc-b4a3-83d21940bee0'
                                        }

                                    />
                                    <CardContent className={cardStyles.content}>
                                        <TextInfoContent
                                            classes={styles}
                                            overline={'Udemy'}
                                            heading={'Java Masterclass For Software Developers'}
                                            body={
                                                ''
                                            }
                                        />
                                        <Button href="http://ude.my/UC-7f060b5a-5e4d-4084-b1aa-abfa0132b520" className={styles.button}>Certificate</Button>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4} lg={4} order={{ xs: 2, sm: 3 }}>
                                <Card className={cx(cardStyles.root, shadowStyles.root)}>
                                    <BrandCardHeader
                                        image={
                                            'https://firebasestorage.googleapis.com/v0/b/my-portfolio-a8cf3.appspot.com/o/logos%2FudemyLogo.png?alt=media&token=4e02e529-8d2b-42bc-b4a3-83d21940bee0'
                                        }

                                    />
                                    <CardContent className={cardStyles.content}>
                                        <TextInfoContent
                                            classes={styles}
                                            overline={'Udemy'}
                                            heading={'The Complete Oracle SQL Certification Course'}
                                            body={
                                                ''
                                            }
                                        />
                                        <Button href="https://ude.my/UC-18830982-696c-45f7-980e-a06843f6d4b0" className={styles.button}>Certificate</Button>
                                    </CardContent>
                                </Card>
                            </Grid>



                        </Grid>

                        <Grid
                            style={{ padding: 16 }}
                            classes={gridStyles}
                            container
                            spacing={4}
                            justify="flex-start"
                        >
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                <Card className={cx(cardStyles.root, shadowStyles.root)}>
                                    <BrandCardHeader
                                        image={
                                            'https://firebasestorage.googleapis.com/v0/b/my-portfolio-a8cf3.appspot.com/o/logos%2FudemyLogo.png?alt=media&token=4e02e529-8d2b-42bc-b4a3-83d21940bee0'
                                        }

                                    />
                                    <CardContent className={cardStyles.content}>
                                        <TextInfoContent
                                            classes={styles}
                                            overline={'Udemy'}
                                            heading={'Snowflake Decoded - Fundamentals'}
                                            body={
                                                ''
                                            }
                                        />
                                        <Button href="https://ude.my/UC-c85bdab0-f0c1-4f3e-84b3-7a812df50b36" className={styles.button}>Certificate</Button>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4} lg={4} order={{ xs: 3, sm: 2 }}>
                                <Card className={cx(cardStyles.root, shadowStyles.root)}>
                                    <BrandCardHeader
                                        image={
                                            'https://firebasestorage.googleapis.com/v0/b/my-portfolio-a8cf3.appspot.com/o/logos%2FudemyLogo.png?alt=media&token=4e02e529-8d2b-42bc-b4a3-83d21940bee0'
                                        }

                                    />
                                    <CardContent className={cardStyles.content}>
                                        <TextInfoContent
                                            classes={styles}
                                            overline={'Udemy'}
                                            heading={'Introduction to Cloud Computing'}
                                            body={
                                                ''
                                            }
                                        />
                                        <Button href="https://ude.my/UC-5976ed31-3ce4-4590-9cda-e3399d382774" className={styles.button}>Certificate</Button>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4} lg={4} order={{ xs: 2, sm: 3 }}>
                                <Card className={cx(cardStyles.root, shadowStyles.root)}>
                                    <BrandCardHeader
                                        image={
                                            'https://firebasestorage.googleapis.com/v0/b/my-portfolio-a8cf3.appspot.com/o/logos%2FudemyLogo.png?alt=media&token=4e02e529-8d2b-42bc-b4a3-83d21940bee0'
                                        }

                                    />
                                    <CardContent className={cardStyles.content}>
                                        <TextInfoContent
                                            classes={styles}
                                            overline={'Udemy'}
                                            heading={'Data Warehousing Fundamentals'}
                                            body={
                                                ''
                                            }
                                        />
                                        <Button href="https://ude.my/UC-776d1522-65a6-4a5b-979b-8c22dfed3f14" className={styles.button}>Certificate</Button>
                                    </CardContent>
                                </Card>
                            </Grid>



                        </Grid>
                    </Fade>

                </div>
            </div>
        </div>
    )
}

export default Courses
